import LoadingSkeleton, {
  SkeletonProps as LoadingSkeletonProps
} from "react-loading-skeleton";
import { ReactElement } from "react";

import "react-loading-skeleton/dist/skeleton.css";

// propsをカスタムする時は👇に追加
type SkeletonProps = LoadingSkeletonProps & {};

// MEMO: react-loading-skeletonのskeletonはspanタグでwrapされているのでheightやwidthが効かないことがある
// MEMO: その場合はcontainerClassNameでwrap要素にスタイルを設定できるのでそこで調整する
const Skeleton = ({ ...props }: SkeletonProps): ReactElement => {
  return <LoadingSkeleton {...props} />;
};

export default Skeleton;
